import { utils } from '@cpc/comment-sdk-common';
import { computed } from 'vue'

export function useMsgCenterSub(options = {}) {
  const { query } = utils;

  const isFromMsgCenter = computed(() => {
    return query.get('isFromMsgCenter') || false;
  });

  return {
    isFromMsgCenter,
  };
}
